import { type Column } from '~/components/Table/Table';
import Table from '~/components/Table/Table';

export default Table;
export { Column };
